export default "__VITE_ASSET__kzAB80vXE9YGCOqDVaRJ_A__"